
import { CmhContactState } from '@/store/new-connection-cmh/cmh-contact/types';
import { RootState } from '@/store/types';
import { ActionTree } from 'vuex';

export const actions: ActionTree<CmhContactState, RootState> = {}
